import { render, staticRenderFns } from "./injectionList.vue?vue&type=template&id=797695fc&scoped=true&"
import script from "./injectionList.vue?vue&type=script&lang=js&"
export * from "./injectionList.vue?vue&type=script&lang=js&"
import style0 from "./injectionList.vue?vue&type=style&index=0&id=797695fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797695fc",
  null
  
)

export default component.exports